import React, { useEffect, useState, useCallback } from 'react';
import dayjs, { Dayjs } from 'dayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

interface LoansListDateFilterProps {
    DefaultDate: string;
    OutputDate: (date: string) => void;
}

const LoansListDateFilter: React.FC<LoansListDateFilterProps> =
    ({ DefaultDate, OutputDate }) => {

        // Parse DefaultDate safely, handling various formats
        const [value, setValue] = useState<Dayjs | null>(() => {
            try {
                // Try parsing the DefaultDate, fallback to current date if invalid
                const parsed = dayjs(DefaultDate);
                return parsed.isValid() ? parsed : dayjs();
            } catch {
                return dayjs(); // Fallback to current date
            }
        });

        // Memoized callback to prevent unnecessary re-renders
        const handleDateChange = useCallback((newValue: Dayjs | null) => {
            if (newValue) {
                setValue(newValue);
            }
        }, []);

        useEffect(() => {
            if (value && value.isValid()) {
                try {
                    const formattedDate = value.format('MM-DD-YYYY');
                    OutputDate(formattedDate);
                } catch (error) {
                    // Fallback to current date if formatting fails
                    const fallbackDate = dayjs().format('MM-DD-YYYY');
                    OutputDate(fallbackDate);
                }
            }
        }, [value, OutputDate]);

        return (
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                    label="Select Date"
                    value={value}
                    onChange={handleDateChange}
                    slotProps={{
                        textField: {
                            size: 'small',
                            fullWidth: true
                        }
                    }}
                />
            </LocalizationProvider>
        )
    }

export default LoansListDateFilter;